var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 15H13.3333V13.3333H2.5V15ZM2.5 10.8333H10.8333V9.16667H2.5V10.8333ZM2.5 5V6.66667H13.3333V5H2.5ZM17.5 12.9917L14.5167 10L17.5 7.00833L16.325 5.83333L12.1583 10L16.325 14.1667L17.5 12.9917Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menu_close.5b666980a31595dba4a9d134066c1942.svg";
export { ForwardRef as ReactComponent };